<template>
    <div>
        <Field
                clearable
                v-model="position"
                label="勘察位置"
                placeholder="请输入勘察位置"
                required
                :rules="[{ required: true, message: '勘察位置不能为空' }]"
        />
        <Field
                clearable
                label="所属单位"
                placeholder="请选择所属单位"
                v-model="unitName"
                right-icon="arrow-down"
                required
                @click="unitPanel=true"
                :rules="[{ required: true, message: '所属单位必填' }]"
        />
        <Field
                clearable
                v-model="templateName"
                label="所属模板"
                required
                @click="selectTemplate"
                placeholder="请选择所属模板"
                right-icon="arrow-down"
                :rules="[{ required: true, message: '所属模板不为空' }]"
        />
        <Button type="info" block style="width: 90% ; margin: 10px auto;" @click="submitTask">确定</Button>
        <SelectTreePopup :show="unitPanel" :defaultSelected="task.unitId?{id:task.unitId,name:task.unitName}:{}"
                         :treeData="unitList"
                         :defaultTitle="task.unitName || '选择单位'" @ok="onUnitOk" @cancel="unitPanel=false"/>
        <SelectPanel :data="template" :show="templatePanel" @cancel="onCancel" @ok="onOk"/>
    </div>
</template>

<script>
    import {Button, Field, Form, NavBar, Popup} from "vant"
    import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup"
    import {mapGetters} from 'vuex'
    import SelectPanel from "@/components/SelectPanel";

    export default {
        components: {SelectPanel, SelectTreePopup, Popup, Form, Field, Button, NavBar},
        props: {
            type: {type: String, default: "default"},
        },
        data() {
            return {
                templatePanel: false,
                unitPanel: false,
                templateName: null,
                position: null,
                task: {
                    unitId: null,
                    unitName: null,
                },
                template: []
            }
        },
        computed: {
            ...mapGetters({unitList: 'global/unitList'}),
            unitName() {
                return this.task.unitName || '选择单位'
            }
        },
        created() {
            this.$initUnit(this.task)
        },
        mounted() {
            this.getTemplate();
        },
        methods: {
            onUnitOk(data) {
                this.unitPanel = false
                this.task.unitId = data.id
                this.task.unitName = data.name
            },
            submitTask() {
                this.$toast.loading("正在处理中....")
                this.$http.tokiot.prospect.task.create({
                    unitId: this.task.unitId,
                    position: this.position,
                    templateId: this.templateId
                }).then(res => {
                    if (res) {
                        this.$toast.success("添加成功")
                        setTimeout(()=>this.$router.go(-1),1000)
                    }
                })
            },
            selectTemplate() {
                this.data = this.template;
                this.templatePanel = true;
            },
            onOk(data) {
                if (data) {
                    this.templateId = data.value;
                    this.templateName = data.text;
                }
                this.templatePanel = !this.templatePanel;
            },
            onCancel() {
                this.templatePanel = false;
            },
            getTemplate() {
                this.$http.tokiot.prospect.template.listTask({}).then(template => {
                    let array = [];
                    template.forEach(data => {
                        if (data.id) {
                            array.push({
                                text: data.name,
                                value: data.id
                            })
                        }
                    })
                    this.template = array;
                })
            },
            updateShow() {
                this.selectShow = true;
            },
        },
        watch: {
        }
    }
</script>

<style scoped>

</style>